<template>
  <div class="bbp-modal-window">
    <div class="bbp-modal-window__content"
         :class="{'bbp-modal-window__content_album': album}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPModalWindow',
  props: ['album'],
  methods: {
    closeWindow () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-modal-window {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: rgba($color-black, 0.5);
    z-index: 999;

    &__content {
      &_album {
        max-height: calc(100vh - 60px)
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPModalWindow/BBPModalWindow.vue